"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var operators_1 = require("rxjs/operators");
var VulnerableCustomerAction_1 = require("../../model/VulnerableCustomerAction");
var Page_1 = require("../Page");
var Confirmation_1 = require("../Confirmation");
var VulnerableCustomerAdditionalSupportModal_1 = require("../../components/modals/VulnerableCustomerAdditionalSupportModal");
var react_router_dom_1 = require("react-router-dom");
var services_1 = require("@falcon/services");
var Tree_1 = require("../../components/Tree");
var Action = function (_a) {
    var children = _a.children, onClick = _a.onClick, disabled = _a.disabled;
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { role: "button", className: disabled ? "text-gray" : "text-primary on-hover-underline cursor-pointer", onClick: disabled ? undefined : onClick, children: children }) }));
};
var VulnerableCustomerActionsTree = /** @class */ (function (_super) {
    __extends(VulnerableCustomerActionsTree, _super);
    function VulnerableCustomerActionsTree(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .getActiveVulnerableCustomerAction(_this.props.policyNumber)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (action) {
                    _this.setState({ activeAction: action });
                });
            });
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .getNumberOfRemainingInstalments(_this.props.customerId, _this.props.policyVersionId)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (remainingInstalments) {
                    _this.setState({
                        remainingInstalments: remainingInstalments,
                        customerHasActiveMonthlyPolicy: remainingInstalments !== undefined && remainingInstalments > 0,
                        customerHasActiveAnnualPolicy: remainingInstalments === 0
                    });
                });
            });
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .getActiveAdditionalSupportRecord(_this.props.policyNumber)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (record) {
                    _this.setState({
                        policyActiveAdditionalSupportRecord: record
                    });
                });
            });
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .getDelinquencyHistoryByPolicyNumber(_this.props.policyNumber)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (delinquencyHistory) {
                    _this.setState({ delinquencyHistory: delinquencyHistory });
                });
            });
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .getPolicyVersionDetails(_this.props.customerId, _this.props.policyNumber, _this.props.policyVersionNumber)
                    .pipe((0, operators_1.switchMap)(function (policyVersionDetails) {
                    return _this.supportPortalService
                        .getInteraction(policyVersionDetails.interactionId);
                }), (0, operators_1.map)(function (interaction) { return services_1.productHelper.isDirectDebit(interaction); }), (0, operators_1.tap)(function (result) { return _this.setState({ isDirectDebit: result }); }), (0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe();
            });
        };
        _this.render = function () { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [_this.renderCancelActionDisclaimer(), _this.renderConfirmationModal(), (0, jsx_runtime_1.jsx)("div", { id: "vulnerable-actions-tree", children: (0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "Vulnerable Customer actions", "data-type": (_this.state.activeAction && _this.state.activeAction !== VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE) ?
                            (0, jsx_runtime_1.jsx)("span", { children: "\uD83D\uDEA9" }) : "", children: [(_this.state.activeAction && _this.state.policyActiveAdditionalSupportRecord) && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [_this.state.customerHasActiveMonthlyPolicy && _this.renderAction(VulnerableCustomerAction_1.VulnerableCustomerActionEnum.CANCEL_FUTURE_INTEREST, "Cancel Future Interest", "Resume Future Interest"), _this.state.customerHasActiveMonthlyPolicy && _this.renderAction(VulnerableCustomerAction_1.VulnerableCustomerActionEnum.SUSPEND_INTEREST, "Suspend Interest", "Resume suspended Interest"), _this.state.customerHasActiveMonthlyPolicy && !_this.state.isDirectDebit && _this.renderAction(VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY, "Payment Holiday", "Cancel Payment Holiday"), _this.state.customerHasActiveMonthlyPolicy && _this.state.isDirectDebit && _this.renderPaymentHolidayAction("Payment Holiday", "Cancel Payment Holiday"), (_this.state.customerHasActiveMonthlyPolicy || _this.state.customerHasActiveAnnualPolicy) && _this.renderAction(VulnerableCustomerAction_1.VulnerableCustomerActionEnum.STOP_FUTURE_CANCELLATION_FEES, "Stop Future Cancellation Fees", "Resume Future Cancellation Fees"), (_this.state.customerHasActiveMonthlyPolicy || _this.state.customerHasActiveAnnualPolicy) && _this.renderAction(VulnerableCustomerAction_1.VulnerableCustomerActionEnum.REFUND_CANCELLATION_FEE, "Refund Cancellation Fee", "Refund Cancellation Fee")] }), _this.renderAdditionalSupportAction(), _this.renderAdditionalSupportPopup(), _this.state.redirectToViewAdditionalSupport && (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/customers/".concat(_this.props.customerId, "/vulnerableCustomer/additionalSupport/").concat(_this.props.policyNumber) })] }) })] })); };
        _this.renderCancelActionDisclaimer = function () { return ((0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: _this.state.showCancelActionDisclaimer, hide: function () { return _this.setState({ showCancelActionDisclaimer: !_this.state.showCancelActionDisclaimer }); }, confirm: function () { return _this.setState({ showCancelActionDisclaimer: !_this.state.showCancelActionDisclaimer }); }, title: "", children: "The ability to reverse Vulnerable Customer actions is not yet implemented" })); };
        _this.renderConfirmationModal = function () {
            var content;
            if (_this.state.actionToConfirmMaxMonths) {
                content = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Select for how many months will the ", _this.state.actionToConfirm, " action be active:"] }), (0, jsx_runtime_1.jsxs)("select", { id: "vulnerable-customer-action-months", className: "form-control", name: "months", value: _this.state.actionToConfirmMonths, onChange: _this.handleMonthChange, children: __spreadArray([(0, jsx_runtime_1.jsx)("option", { value: 0, children: "Please select..." })], Array(_this.state.actionToConfirmMaxMonths).fill(null).map(function (v, i) { return ((0, jsx_runtime_1.jsx)("option", { value: i + 1, children: i + 1 }, i + 1)); }), true) })] }));
            }
            else {
                content = (0, jsx_runtime_1.jsxs)("p", { children: ["Are you sure you want to start ", _this.state.actionToConfirm, " action?"] });
            }
            return ((0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: _this.state.showConfirmationModal, hide: _this.toggleConfirmationModal, confirm: function () { return _this.startAction(); }, title: "Vulnerable Customer action confirmation", children: content }));
        };
        _this.toggleConfirmationModal = function () {
            _this.setState(function (prevState) { return ({
                showConfirmationModal: !prevState.showConfirmationModal
            }); });
        };
        _this.handleMonthChange = function (event) {
            _this.setState({
                actionToConfirmMonths: parseInt(event.target.value, 10)
            });
        };
        _this.renderAction = function (action, startActionText, cancelActionText) {
            var activeAction = _this.state.activeAction;
            var isActive = activeAction === action;
            var isDisabled = !isActive && activeAction !== VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE;
            return ((0, jsx_runtime_1.jsx)(Action, { onClick: isActive
                    ? function () { return _this.stopAction(action); }
                    : function () { return _this.startActionConfirmation(action); }, disabled: isDisabled, children: isActive ? cancelActionText : startActionText }));
        };
        _this.renderAdditionalSupportAction = function () {
            return ((0, jsx_runtime_1.jsx)("div", { id: "additional-support-action", children: (0, jsx_runtime_1.jsx)(Action, { onClick: _this.state.policyActiveAdditionalSupportRecord
                        ? function () { return _this.viewAdditionalSupportRecord(); }
                        : function () { return _this.addAdditionalSupportRecord(); }, children: _this.state.policyActiveAdditionalSupportRecord ? "View/Edit additional support" : "Add additional support" }) }));
        };
        _this.addAdditionalSupportRecord = function () {
            _this.supportPortalService.logAgentActivity(_this.props.customerId, { "action": "No Action", "customer": _this.props.policyNumber }).subscribe(function (agentActivity) {
                _this.setState({ agentActivityId: agentActivity.id });
            });
            _this.setState({
                showAdditionalSupportAddRecordPopup: true
            });
        };
        _this.viewAdditionalSupportRecord = function () {
            _this.setState({
                redirectToViewAdditionalSupport: true
            });
        };
        _this.renderAdditionalSupportPopup = function () {
            return ((0, jsx_runtime_1.jsx)(VulnerableCustomerAdditionalSupportModal_1.default, { policyNumber: _this.props.policyNumber, customerReferenceNumber: _this.props.customerId, newAdditionalSupport: true, isOpen: _this.state.showAdditionalSupportAddRecordPopup, onClose: function () { return _this.setState({ showAdditionalSupportAddRecordPopup: false }); }, onSuccess: function (record) {
                    var _a;
                    _this.supportPortalService.logAgentActivity(_this.props.customerId, { "action": "add VC additional support", "customer": _this.props.policyNumber, "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString() }).subscribe();
                    _this.setState({
                        showAdditionalSupportAddRecordPopup: false,
                        policyActiveAdditionalSupportRecord: record
                    });
                } }));
        };
        _this.startActionConfirmation = function (action) {
            var actionToConfirmMaxMonths;
            switch (action) {
                case VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY:
                    actionToConfirmMaxMonths = 3;
                    break;
                case VulnerableCustomerAction_1.VulnerableCustomerActionEnum.SUSPEND_INTEREST:
                    actionToConfirmMaxMonths = _this.state.remainingInstalments;
                    break;
                default:
                    actionToConfirmMaxMonths = undefined;
            }
            _this.setState({
                showConfirmationModal: true,
                actionToConfirm: action,
                actionToConfirmMaxMonths: actionToConfirmMaxMonths
            });
        };
        _this.startAction = function () {
            if (_this.state.activeAction !== VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE) {
                return;
            }
            if (!_this.state.actionToConfirmMonths && (_this.state.actionToConfirm === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.SUSPEND_INTEREST
                || _this.state.actionToConfirm === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY)) {
                return;
            }
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .startVulnerableCustomerAction(_this.props.customerId, _this.props.policyNumber, _this.state.actionToConfirm, _this.state.actionToConfirmMonths)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function () {
                    if (_this.state.actionToConfirm === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.REFUND_CANCELLATION_FEE) {
                        // Refund Cancellation Fee is not a continuous action
                        return;
                    }
                    _this.props.onActionChange();
                    _this.setState({
                        activeAction: _this.state.actionToConfirm,
                        actionToConfirm: VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE,
                        actionToConfirmMonths: undefined,
                        actionToConfirmMaxMonths: undefined
                    });
                });
            });
            _this.storeActionInAdditionalSupportRecord();
        };
        _this.stopAction = function (action) {
            if ((action === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.CANCEL_FUTURE_INTEREST ||
                action === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.STOP_FUTURE_CANCELLATION_FEES ||
                action === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY ||
                action === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.SUSPEND_INTEREST)
                && _this.state.activeAction === action) {
                _this.context.loadingQueue.increment(function () {
                    _this.supportPortalService
                        .cancelVulnerableCustomerAction(_this.props.customerId, _this.props.policyNumber, action)
                        .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                        .subscribe(function () {
                        _this.setState({ activeAction: VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE });
                        _this.props.onActionChange();
                    });
                });
                _this.storeActionInAdditionalSupportRecord();
            }
            else {
                _this.setState({
                    showCancelActionDisclaimer: true
                });
            }
        };
        _this.storeActionInAdditionalSupportRecord = function () {
            _this.state.policyActiveAdditionalSupportRecord.appliedAction = _this.state.actionToConfirm;
            _this.state.policyActiveAdditionalSupportRecord.partyReference = _this.props.customerId;
            _this.context.loadingQueue.increment(function () {
                _this.supportPortalService
                    .updateAdditionalSupportRecord(_this.state.policyActiveAdditionalSupportRecord)
                    .pipe((0, operators_1.finalize)(_this.context.loadingQueue.decrement))
                    .subscribe(function (error) {
                    if (error) {
                        new Error('Could not store action for additional support record');
                    }
                    else {
                        _this.setState({
                            showConfirmationModal: false
                        });
                    }
                });
            });
        };
        _this.hasPendingRepresent = function () {
            var _a;
            var result = (_a = _this.state.delinquencyHistory) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.type === "Lack of funds"; });
            if (result === undefined) {
                return false;
            }
            return result.status === "Active" && (result.nextAction === "Day 5" || result.nextAction === "Day 14");
        };
        _this.renderPaymentHolidayAction = function (startActionText, cancelActionText) {
            var activeAction = _this.state.activeAction;
            var isActive = activeAction === VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY;
            var isDisabled = !isActive && activeAction !== VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE;
            var linkToPaymentHolidayOptions = _this.hasPendingRepresent()
                ? "/customers/".concat(_this.props.customerId, "/vulnerableCustomer/paymentHolidays/pendingRepresent")
                : "/customers/".concat(_this.props.customerId, "/vulnerableCustomer/paymentHolidays/").concat(_this.props.policyNumber, "/process");
            return (isActive ?
                (0, jsx_runtime_1.jsx)("button", { onClick: function () { return _this.stopAction(VulnerableCustomerAction_1.VulnerableCustomerActionEnum.PAYMENT_HOLIDAY); }, className: "text-primary btn-link btn-unstyled d-block", children: cancelActionText })
                : (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: linkToPaymentHolidayOptions, className: isDisabled ? "text-gray" : "text-primary on-hover-underline cursor-pointer", children: isActive ? cancelActionText : startActionText }));
        };
        _this.state = {
            activeAction: VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE,
            actionToConfirm: VulnerableCustomerAction_1.VulnerableCustomerActionEnum.NONE,
            showConfirmationModal: false,
            showCancelActionDisclaimer: false,
            customerHasActiveAnnualPolicy: false,
            customerHasActiveMonthlyPolicy: false,
            showAdditionalSupportAddRecordPopup: false,
            redirectToViewAdditionalSupport: false,
            isDirectDebit: false
        };
        return _this;
    }
    VulnerableCustomerActionsTree.contextType = Page_1.PageContext;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], VulnerableCustomerActionsTree.prototype, "supportPortalService", void 0);
    return VulnerableCustomerActionsTree;
}(React.Component));
exports.default = VulnerableCustomerActionsTree;
//# sourceMappingURL=VulnerableCustomerActionsTree.js.map